import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const ProtectedRoute = ({ children, adminOnly = false, hinweis = false }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();
  const { t } = useTranslation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f5f8fa]">
        <Loader2 className="w-8 h-8 text-[#b8893d] animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated && hinweis) {
    const next = encodeURIComponent(location.pathname + location.search);
    return (
      <div className="min-h-screen flex flex-col bg-[#f5f8fa]">
      <Header />
      <div className="flex-1 pt-[190px] pb-20 flex items-center justify-center px-4" data-testid="login-pflicht-hinweis">
        <div className="max-w-md w-full bg-white border border-gray-200 p-8 rounded-sm">
          <h1 className="font-serif text-2xl text-[#1B3A5C] mb-3">{t('login_pflicht.titel')}</h1>
          <p className="text-sm text-[#34536b] leading-relaxed">{t('login_pflicht.text')}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={`/login?next=${next}`} className="px-5 py-2.5 bg-[#1B3A5C] text-white text-xs tracking-wider rounded-sm" data-testid="login-pflicht-anmelden">{t('login_pflicht.anmelden')}</a>
            <a href={`/register?next=${next}`} className="px-5 py-2.5 border border-[#b8893d] text-[#1B3A5C] text-xs tracking-wider rounded-sm" data-testid="login-pflicht-registrieren">{t('login_pflicht.registrieren')}</a>
            <a href="/mandantenerfassung" className="px-5 py-2.5 text-[#1B3A5C] text-xs tracking-wider underline" data-testid="login-pflicht-erfassung">{t('login_pflicht.erfassung')}</a>
          </div>
        </div>
      </div>
      <Footer />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} state={{ from: location.pathname + location.search }} replace />;
  }

  if (adminOnly && !['admin', 'kanzlei_mitarbeiter'].includes(user?.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
